// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   갤러리 — 앨범 목록 · 라이트박스 · 홈 "Recent work" 스트립
   ══════════════════════════════════════════════════════════════════ */
.gal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;
  margin-top: 24px;
}

.g-card {
  display: block;
  text-align: left;
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  background: var(--surface);
  overflow: hidden;
  cursor: pointer;
  transition: transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease), border-color var(--dur);
}

.g-card:hover,
.g-card:focus-visible {
  transform: translate(-3px, -3px);
  box-shadow: var(--sh-iso);
  border-color: var(--brand-soft-2);
  outline: none;
}

.g-fig {
  position: relative;
  margin: 0; /* figure default margin would inset the photo inside the card */
  aspect-ratio: 4 / 3;
  background: var(--surface-2);
  overflow: hidden;
}

.g-fig img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s var(--ease);
}

.g-card:hover .g-fig img {
  transform: scale(1.04);
}

/* 구분 칩 — Our work / Workshop. 두 갈래가 다 있을 때만 보인다 */
.gal-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 22px;
}

.gal-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  border: 1px solid var(--line);
  border-radius: var(--r-pill);
  background: var(--surface);
  color: var(--ink-2);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color var(--dur), background var(--dur), color var(--dur), transform var(--dur) var(--ease);
}

.gal-chip span {
  font-family: var(--f-m);
  font-size: 10.5px;
  letter-spacing: 0.06em;
  color: var(--ink-3);
}

.gal-chip:hover,
.gal-chip:focus-visible {
  border-color: var(--brand-soft-2);
  color: var(--ink);
  outline: none;
}

.gal-chip.is-on {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.gal-chip.is-on span {
  color: rgba(255, 255, 255, 0.72);
}

.gal-filter-lede {
  flex-basis: 100%;
  margin: 4px 0 0;
  font-size: 13.5px;
  color: var(--ink-3);
}

/* 구분 태그 — 카드 왼쪽 위 */
.g-kind {
  position: absolute;
  left: 10px;
  top: 10px;
  padding: 4px 9px;
  border-radius: var(--r-pill);
  background: rgba(255, 255, 255, 0.92);
  color: var(--ink-2);
  font-family: var(--f-m);
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  backdrop-filter: blur(4px);
}

.g-kind--work {
  background: var(--brand);
  color: #fff;
}

/* 사진 수 배지 */
.g-count {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: var(--r-pill);
  background: rgba(12, 17, 24, 0.62);
  color: #fff;
  font-family: var(--f-m);
  font-size: 10.5px;
  letter-spacing: 0.06em;
  backdrop-filter: blur(4px);
}

.g-cap {
  padding: 14px 16px 16px;
}

.g-cap b {
  display: block;
  font-family: var(--f-d);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.g-cap small {
  display: block;
  margin-top: 5px;
  font-size: 13px;
  color: var(--ink-3);
  line-height: 1.5;
}

.g-cap .g-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── 라이트박스 ───────────────────────────────────── */
.lb {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(240px, 0.7fr);
  gap: 26px;
  align-items: start;
}

.lb-fig {
  position: relative;
  border-radius: var(--r-2);
  background: var(--surface-2);
  overflow: hidden;
}

.lb-fig img {
  display: block;
  width: 100%;
  max-height: 62vh;
  object-fit: contain;
  animation: fade 0.25s ease both;
}

.lb-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: var(--ink);
  display: grid;
  place-items: center;
  box-shadow: var(--sh-2);
}

.lb-nav--prev { left: 12px; }
.lb-nav--next { right: 12px; }

.lb-thumbs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.lb-thumbs button {
  flex: none;
  width: 72px;
  height: 54px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  background: var(--surface-2);
  opacity: 0.7;
  transition: opacity var(--dur), border-color var(--dur);
}

.lb-thumbs button img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lb-thumbs button:hover,
.lb-thumbs button.is-on {
  opacity: 1;
}

.lb-thumbs button.is-on {
  border-color: var(--brand);
}

.lb-side h3 {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-top: 8px;
}

.lb-side p {
  margin-top: 12px;
  color: var(--ink-2);
  font-size: 14.5px;
  line-height: 1.6;
}

.lb-count {
  font-family: var(--f-m);
  font-size: 11px;
  color: var(--ink-3);
  letter-spacing: 0.08em;
}

@media (max-width: 760px) {
  .lb {
    grid-template-columns: 1fr;
  }
  .lb-fig img {
    max-height: 44vh;
  }
}

/* ── 홈 스트립 ────────────────────────────────────── */
.home-gallery .sec-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  max-width: none;
  flex-wrap: wrap;
}

.home-gallery .sec-head > div {
  max-width: 62ch;
}

.hg-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 210px;
  gap: 16px;
}

.hg-grid .g-card:first-child {
  grid-column: span 2;
  grid-row: span 2;
}

.hg-grid .g-fig {
  aspect-ratio: auto;
  height: 100%;
}

.hg-grid .g-card {
  position: relative;
}

.hg-grid .g-count {
  bottom: auto;
  top: 10px;
}

.hg-grid .g-cap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 36px 16px 14px;
  background: linear-gradient(180deg, rgba(12, 17, 24, 0) 0%, rgba(12, 17, 24, 0.72) 100%);
  color: #fff;
}

.hg-grid .g-cap b {
  font-size: 15px;
}

.hg-grid .g-card:first-child .g-cap b {
  font-size: 20px;
}

@media (max-width: 960px) {
  .hg-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 190px;
  }
  .hg-grid .g-card:first-child {
    grid-column: span 2;
    grid-row: span 1;
  }
}

@media (max-width: 640px) {
  .gal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .g-cap {
    padding: 10px 12px 12px;
  }
  .g-cap b {
    font-size: 14px;
  }
  .g-cap small {
    font-size: 12px;
  }
  .g-count {
    right: 8px;
    bottom: 8px;
    font-size: 9.5px;
  }
  .g-kind {
    left: 8px;
    top: 8px;
    font-size: 9px;
    padding: 3px 7px;
  }
  .gal-chip {
    padding: 7px 12px;
    font-size: 13px;
  }
  .hg-grid {
    grid-auto-rows: 160px;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/gallery/gallery.css"],"names":[],"mappings":"AAAA;;uEAEuE;AACvE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,wGAAwG;AAC1G;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,gEAAgE;EAC3E,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8GAA8G;AAChH;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB,UAAU,EAAE;AAC5B,gBAAgB,WAAW,EAAE;;AAE7B;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,wFAAwF;EACxF,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;IAChD,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,QAAQ;IACR,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,SAAS;EACX;AACF","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\r\n   갤러리 — 앨범 목록 · 라이트박스 · 홈 \"Recent work\" 스트립\r\n   ══════════════════════════════════════════════════════════════════ */\r\n.gal-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 22px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.g-card {\r\n  display: block;\r\n  text-align: left;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-3);\r\n  background: var(--surface);\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  transition: transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease), border-color var(--dur);\r\n}\r\n\r\n.g-card:hover,\r\n.g-card:focus-visible {\r\n  transform: translate(-3px, -3px);\r\n  box-shadow: var(--sh-iso);\r\n  border-color: var(--brand-soft-2);\r\n  outline: none;\r\n}\r\n\r\n.g-fig {\r\n  position: relative;\r\n  margin: 0; /* figure default margin would inset the photo inside the card */\r\n  aspect-ratio: 4 / 3;\r\n  background: var(--surface-2);\r\n  overflow: hidden;\r\n}\r\n\r\n.g-fig img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.6s var(--ease);\r\n}\r\n\r\n.g-card:hover .g-fig img {\r\n  transform: scale(1.04);\r\n}\r\n\r\n/* 구분 칩 — Our work / Workshop. 두 갈래가 다 있을 때만 보인다 */\r\n.gal-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.gal-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 8px 14px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-pill);\r\n  background: var(--surface);\r\n  color: var(--ink-2);\r\n  font-size: 13.5px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: border-color var(--dur), background var(--dur), color var(--dur), transform var(--dur) var(--ease);\r\n}\r\n\r\n.gal-chip span {\r\n  font-family: var(--f-m);\r\n  font-size: 10.5px;\r\n  letter-spacing: 0.06em;\r\n  color: var(--ink-3);\r\n}\r\n\r\n.gal-chip:hover,\r\n.gal-chip:focus-visible {\r\n  border-color: var(--brand-soft-2);\r\n  color: var(--ink);\r\n  outline: none;\r\n}\r\n\r\n.gal-chip.is-on {\r\n  background: var(--ink);\r\n  border-color: var(--ink);\r\n  color: #fff;\r\n}\r\n\r\n.gal-chip.is-on span {\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.gal-filter-lede {\r\n  flex-basis: 100%;\r\n  margin: 4px 0 0;\r\n  font-size: 13.5px;\r\n  color: var(--ink-3);\r\n}\r\n\r\n/* 구분 태그 — 카드 왼쪽 위 */\r\n.g-kind {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  padding: 4px 9px;\r\n  border-radius: var(--r-pill);\r\n  background: rgba(255, 255, 255, 0.92);\r\n  color: var(--ink-2);\r\n  font-family: var(--f-m);\r\n  font-size: 10px;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.g-kind--work {\r\n  background: var(--brand);\r\n  color: #fff;\r\n}\r\n\r\n/* 사진 수 배지 */\r\n.g-count {\r\n  position: absolute;\r\n  right: 10px;\r\n  bottom: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 4px 9px;\r\n  border-radius: var(--r-pill);\r\n  background: rgba(12, 17, 24, 0.62);\r\n  color: #fff;\r\n  font-family: var(--f-m);\r\n  font-size: 10.5px;\r\n  letter-spacing: 0.06em;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.g-cap {\r\n  padding: 14px 16px 16px;\r\n}\r\n\r\n.g-cap b {\r\n  display: block;\r\n  font-family: var(--f-d);\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  line-height: 1.3;\r\n}\r\n\r\n.g-cap small {\r\n  display: block;\r\n  margin-top: 5px;\r\n  font-size: 13px;\r\n  color: var(--ink-3);\r\n  line-height: 1.5;\r\n}\r\n\r\n.g-cap .g-desc {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ── 라이트박스 ───────────────────────────────────── */\r\n.lb {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.6fr) minmax(240px, 0.7fr);\r\n  gap: 26px;\r\n  align-items: start;\r\n}\r\n\r\n.lb-fig {\r\n  position: relative;\r\n  border-radius: var(--r-2);\r\n  background: var(--surface-2);\r\n  overflow: hidden;\r\n}\r\n\r\n.lb-fig img {\r\n  display: block;\r\n  width: 100%;\r\n  max-height: 62vh;\r\n  object-fit: contain;\r\n  animation: fade 0.25s ease both;\r\n}\r\n\r\n.lb-nav {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  color: var(--ink);\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: var(--sh-2);\r\n}\r\n\r\n.lb-nav--prev { left: 12px; }\r\n.lb-nav--next { right: 12px; }\r\n\r\n.lb-thumbs {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n  overflow-x: auto;\r\n  padding-bottom: 4px;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.lb-thumbs button {\r\n  flex: none;\r\n  width: 72px;\r\n  height: 54px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  border: 2px solid transparent;\r\n  background: var(--surface-2);\r\n  opacity: 0.7;\r\n  transition: opacity var(--dur), border-color var(--dur);\r\n}\r\n\r\n.lb-thumbs button img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.lb-thumbs button:hover,\r\n.lb-thumbs button.is-on {\r\n  opacity: 1;\r\n}\r\n\r\n.lb-thumbs button.is-on {\r\n  border-color: var(--brand);\r\n}\r\n\r\n.lb-side h3 {\r\n  font-size: 22px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.02em;\r\n  margin-top: 8px;\r\n}\r\n\r\n.lb-side p {\r\n  margin-top: 12px;\r\n  color: var(--ink-2);\r\n  font-size: 14.5px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.lb-count {\r\n  font-family: var(--f-m);\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .lb {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .lb-fig img {\r\n    max-height: 44vh;\r\n  }\r\n}\r\n\r\n/* ── 홈 스트립 ────────────────────────────────────── */\r\n.home-gallery .sec-head {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n  max-width: none;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.home-gallery .sec-head > div {\r\n  max-width: 62ch;\r\n}\r\n\r\n.hg-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  grid-auto-rows: 210px;\r\n  gap: 16px;\r\n}\r\n\r\n.hg-grid .g-card:first-child {\r\n  grid-column: span 2;\r\n  grid-row: span 2;\r\n}\r\n\r\n.hg-grid .g-fig {\r\n  aspect-ratio: auto;\r\n  height: 100%;\r\n}\r\n\r\n.hg-grid .g-card {\r\n  position: relative;\r\n}\r\n\r\n.hg-grid .g-count {\r\n  bottom: auto;\r\n  top: 10px;\r\n}\r\n\r\n.hg-grid .g-cap {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  padding: 36px 16px 14px;\r\n  background: linear-gradient(180deg, rgba(12, 17, 24, 0) 0%, rgba(12, 17, 24, 0.72) 100%);\r\n  color: #fff;\r\n}\r\n\r\n.hg-grid .g-cap b {\r\n  font-size: 15px;\r\n}\r\n\r\n.hg-grid .g-card:first-child .g-cap b {\r\n  font-size: 20px;\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .hg-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    grid-auto-rows: 190px;\r\n  }\r\n  .hg-grid .g-card:first-child {\r\n    grid-column: span 2;\r\n    grid-row: span 1;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .gal-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 12px;\r\n  }\r\n  .g-cap {\r\n    padding: 10px 12px 12px;\r\n  }\r\n  .g-cap b {\r\n    font-size: 14px;\r\n  }\r\n  .g-cap small {\r\n    font-size: 12px;\r\n  }\r\n  .g-count {\r\n    right: 8px;\r\n    bottom: 8px;\r\n    font-size: 9.5px;\r\n  }\r\n  .g-kind {\r\n    left: 8px;\r\n    top: 8px;\r\n    font-size: 9px;\r\n    padding: 3px 7px;\r\n  }\r\n  .gal-chip {\r\n    padding: 7px 12px;\r\n    font-size: 13px;\r\n  }\r\n  .hg-grid {\r\n    grid-auto-rows: 160px;\r\n    gap: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
